export const NON_STANDARD_SHIP_OPTIONS_MAP = {
  '1-Business Day': 'Fastest',
  '2-Business Days': 'Faster',
  '3-5 Business Days': 'Fast',
  '3-7 Business Days': 'Fast',
  '5-10 Business Days': 'Fast',
  '5-7 Business Days': 'Fast'
};
